import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {UserService} from '../../../services/user.service';
import {Globals} from '../../../globals';
import {OperatoriesService} from '../../../modules/configuration/operatories/operatories.service';
import {Constants} from '../../../constants';
import {WorkstationConfigurationModel} from '../../../models/configuration/workstation-configuration.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {NotificationService} from '../../../services/messaging/notification.service';
import {NotificationMessageDataModel} from '../../../models/messaging/notification-message-data.model';
import {NotificationDataModel} from '../../../models/messaging/notification-data.model';
import {NotificationDestinationDataModel} from '../../../models/messaging/notification-destination-data.model';
import {LiveChatService} from '../../../services/live-chat.service';
import {MessagingService} from '../../../services/messaging.service';
import {SignalrService} from '../../../services/socket/signalr.service';
import {ChatService} from '../../../services/messaging/chat.service';
import {SocketMessageModel} from '../../../services/socket/models/socket-message.model';
import {SocketConnectedUserModel} from '../../../services/socket/models/socket-connected-user.model';
import {LocalStorageService} from '../../../services/local-storage.service';
import {Subscription} from 'rxjs';
import {MatTabGroup} from '@angular/material/tabs';
import {NotificationConversationDataModel} from '../../../models/messaging/notification-conversation-data.model';
import {AuthenticationService} from '../../../modules/auth/services/authentication.service';
import {ColorSchemesService} from '../../../modules/configuration/color-schemes/color-schemes.service';
import {ColorSchemeDataModel} from '../../../models/configuration/color-scheme-data.model';

/*interface WorkstationsByOperatory {
  [key: string]: string | boolean | number;
}*/

export class WorkstationOperatoryModel {
  operatoryName: string;
  workstations: WorkstationConfigurationModel[] = [];
  selectedWorkstations: WorkstationConfigurationModel[] = [];
}

@Component({
  selector: 'app-notification-create-dialog',
  templateUrl: './notification-create-dialog.component.html',
  styleUrls: ['./notification-create-dialog.component.scss']
})
export class NotificationCreateDialogComponent implements OnInit {
  @ViewChild('messageContainer') private messageContainer: ElementRef;
  @ViewChild('tabGroup') private tabGroup: MatTabGroup;
  isLoading = true;

  connectedSocketUsers: SocketConnectedUserModel[] = [];
  userList: TdoUserConfigurationModel[];
  selectedUsers: TdoUserConfigurationModel[] = [];

  onlineUsers: TdoUserConfigurationModel[] = [];
  offlineUsers: TdoUserConfigurationModel[] = [];

  workstationList: WorkstationConfigurationModel[];
  selectedWorkstations: WorkstationConfigurationModel[] = [];
  operatoryWorkstations: WorkstationOperatoryModel[] = [];

  predefinedMessages: NotificationMessageDataModel[];
  editedPredefinedMessages: NotificationMessageDataModel[] = [];
  selectedMessage: NotificationMessageDataModel;

  // selectedConversation: TdoChatConversationDataModel;
  // conversations: TdoChatConversationDataModel[];
  conversations: NotificationConversationDataModel[] = [];
  // selectedConversationDestinationGroup: NotificationDestinationDataModel[];
  destinations: NotificationDestinationDataModel[] = [];
  selectedConversation: NotificationConversationDataModel;
  selectedNotifications: NotificationDataModel[] = [];

  messageInEditMode: NotificationMessageDataModel;
  isPopup: boolean = false;
  popupMessage = '';
  chatInput = '';

  scrollTimeout: any;
  chatServiceSubscription: Subscription;

  currentTabName: string = 'Page';

  ENUM_NOTIFICATION_TYPE_PAGE = '00000501-1000-0000-0000-000000000001';
  ENUM_NOTIFICATION_TYPE_IM   = '00000501-1000-0000-0000-000000000002';

  ENUM_NOTIFICATION_PRIORITY_NORMAL     = '00000502-1000-0000-0000-000000000001';
  ENUM_NOTIFICATION_PRIORITY_PRIORITY1  = '00000502-1000-0000-0000-000000000002';
  selectedPriorityId: string = this.ENUM_NOTIFICATION_PRIORITY_NORMAL;
  priority: string = 'N';

  isShowConversations: boolean = false;
  isForceNewConversation: boolean = false;

  notificationType: string = this.ENUM_NOTIFICATION_TYPE_IM;

  colorSchemes: ColorSchemeDataModel[] = [];

  private _selectedOnlineUser: SocketConnectedUserModel;

  constructor(private dialogRef: MatDialogRef<NotificationCreateDialogComponent>,
              private colorSchemeService: ColorSchemesService,
              private opsService: OperatoriesService,
              private globals: Globals,
              private notificationService: NotificationService,
              private liveChatService: LiveChatService,
              private messagingService: MessagingService,
              public signalrService: SignalrService,
              private chatService: ChatService,
              private localStorageService: LocalStorageService,
              public authenticationService: AuthenticationService,
              @Inject(MAT_DIALOG_DATA) private data: NotificationDestinationDataModel,
              private userService: UserService) { }

  ngOnInit(): void {
    this.selectedMessage = new NotificationMessageDataModel();
    this.selectedMessage.Message = '';
    this.colorSchemeService.getColorSchemes().subscribe((schemes) => {
      this.colorSchemes = schemes;
    });

    this.userService.getUsers(this.globals.TDOCID).subscribe((res) => {
      this.userList = res;
      this.updateUsers();

      this.opsService.getWorkstations(this.globals.LOCID, Constants.emptyGuid).subscribe((res1) => {
        this.workstationList = res1;

        for (const model of this.workstationList) {
          let savedModel = this.operatoryWorkstations.find(p => p.operatoryName === model.cfgOperatory.OperatoryName);
          if (!savedModel) {
            savedModel = new WorkstationOperatoryModel();
            savedModel.operatoryName = model.cfgOperatory.OperatoryName;
            savedModel.workstations.push(model);
            this.operatoryWorkstations.push(savedModel);
          }
        }

        this.notificationService.getPredefinedMessages().subscribe((messages) => {
          this.predefinedMessages = messages;
          this.isLoading = false;
          if (this.data) {
            // this.tabGroup.selectedIndex = 1;
            // this.currentTabName = 'Instant Message';
            const user = this.userList.find(p => p.UserID.toLowerCase() === this.data.dataNotification.SenderUserID.toLowerCase());
            if (user) {
              this.onUserClick(user);
            }
          }
          /*const ivl = setInterval(() => {
            if (this.tabGroup) {
              clearInterval(ivl);
              if (this.data) {
                this.tabGroup.selectedIndex = 1;
                // this.currentTabName = 'Instant Message';
                const user = this.userList.find(p => p.UserID.toLowerCase() === this.data.dataNotification.SenderUserID.toLowerCase());
                if (user) {
                  this.onUserClick(user);
                }
              }
            }
          });*/
        });
      });
    });

    if (this.signalrService.connectionExists) {
      this.signalrService.userConnected.subscribe((users) => {
        this.connectedSocketUsers = users;
        this.updateUsers();
      });

      this.signalrService.userDisconnected.subscribe((usersAfterDisconnect) => {
        this.updateUsers();
      });

      this.signalrService.messageUser.subscribe((res) => {
        switch (res.messageType) {
          case SocketMessageModel.TYPE_UPDATE_CHAT:
            if (this.selectedUsers.length === 1) {
              const destination = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
              if (this.selectedConversation) {
                if (this.selectedConversation.ConversationID.toLowerCase() === destination.ConversationID.toLowerCase()
                  && destination.UserID.toLowerCase() === this.authenticationService.currentUserValue.authdata.userid.toLowerCase()) {
                  this.selectedNotifications.push(destination.dataNotification);
                  setTimeout(() => {
                    this.scrollToBottom();
                  }, 2000);
                }
              }
            }
            break;
        }
      });
      this.scrollToBottom();
    }
  }

  updateUsers() {
    if (!this.userList) {
      return;
    }
    this.connectedSocketUsers = this.signalrService.connectedUsers;
    this.onlineUsers = this.userList.filter(p => {
      if (this.connectedSocketUsers.map(e => e.UserID).includes(p.UserID)) {
        return p;
      }
    });

    this.offlineUsers = this.userList.filter(p => {
      if (!this.connectedSocketUsers.map(e => e.UserID).includes(p.UserID)) {
        return p;
      }
    });
  }

  setMessagesAsSeen() {
    /*if (this.selectedConversation && this.selectedConversation.dataTDOChats) {
      const messagesToUpdate = this.selectedConversation.dataTDOChats.filter(p => p.ReceiverID === this.localStorageService.currentUserData.authdata.userid && p.enumNotificationStatusID === NotificationStatusEnum.NEW);
      const messageIdsToUpdate = messagesToUpdate.map(p => p.ChatID);
      if (messageIdsToUpdate.length > 0) {
        this.chatService.updateChatMessageStatus(messageIdsToUpdate, NotificationStatusEnum.READ).subscribe(() => {
          this.chatService.getNumUnreadMessages(this.localStorageService.currentUserData.authdata.userid).subscribe((num) => {
          });
        });
      }
    }*/
  }

  onOkClick() {
    if (this.selectedMessage && this.selectedUsers.length > 0) {
      const message = new NotificationDataModel();
      message.Message = this.selectedMessage.Message;
      message.SenderUserID = this.authenticationService.currentUserValue.authdata.userid;
      message.isPopUp = this.isPopup;
      message.PopMessage = this.popupMessage;
      message.enumNotificationStatusID = '00000199-1000-0000-0000-000000000001';
      message.enumNotificationPriorityID = this.selectedPriorityId;

      const destinations: NotificationDestinationDataModel[] = [];
      for (const user of this.selectedUsers) {
        /*if (this.currentTabName === 'Page') {
          const messageData = new NotificationDestinationDataModel();
          messageData.UserID = user.UserID;
          message.dataNotificationDestinations.push(messageData);
        } else {*/
          const dest = new NotificationDestinationDataModel();
          dest.UserID = user.UserID;
          dest.enumNotificationStatusID = '00000199-1000-0000-0000-000000000001';
          destinations.push(dest);

          if (!this.selectedConversation || this.isForceNewConversation) {
            const conversation = new NotificationConversationDataModel();
            conversation.ReceiverID = user.UserID;
            conversation.SenderUserID = this.authenticationService.currentUserValue.authdata.userid;
            dest.dataNotificationConversation = conversation;
          } else {
            dest.ConversationID = this.selectedConversation.ConversationID;
            dest.dataNotificationConversation = this.selectedConversation;
          }

          const notification = new NotificationDataModel();
          notification.enumNotificationPriorityID = this.selectedPriorityId;
          notification.enumNotificationStatusID = '00000199-1000-0000-0000-000000000001';
          notification.enumNotificationMsgTypeID = this.notificationType;
          notification.SenderUserID = this.authenticationService.currentUserValue.authdata.userid;
          notification.Message = this.selectedMessage.Message;
          dest.dataNotification = notification;
        //}
        // If Instant Message mode, we need a conversation model, either new or old
      }

      /*if (this.currentTabName === 'Page') {
        this.notificationService.sendMessage(message).subscribe(() => {
          this.dialogRef.close();
        });
      } else {*/
        this.notificationService.sendToDestination(this.authenticationService.currentUserValue.authdata.userid, destinations).subscribe((res) => {
          this.destinations.push(res);
          if (this.selectedUsers.length === 1) {
            this.selectedNotifications.push(res[0].dataNotification);
            this.chatInput = '';
            this.scrollToBottom();
          }
        });
      //}
    } else {
      this.dialogRef.close();
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  isUserSelected(user: TdoUserConfigurationModel) {
    return this.selectedUsers.includes(user);
  }

  onUserClick(user: TdoUserConfigurationModel) {
    if (this.selectedUsers.includes(user)) {
      const idx = this.selectedUsers.findIndex(p => p === user);
      if (idx > -1) {
        this.selectedUsers.splice(idx, 1);
      }
    } else {
      this.selectedUsers.push(user);
    }

    /*if (this.currentTabName === 'Instant Message') {*/
      if (this.selectedUsers.length === 1) {
        this.notificationService.getConversations(this.authenticationService.currentUserValue.authdata.userid, this.selectedUsers[0].UserID).subscribe((conversations) => {
          this.selectedConversation = null;
          this.conversations = conversations;
          if (this.conversations && this.conversations.length > 0) {
            this.selectedConversation = this.conversations[0];
            this.onSelectConversation(this.selectedConversation);
          }
        });
      } else if (this.selectedUsers.length > 1) {
        this.selectedConversation = null;
        this.selectedNotifications = [];
      } else {
        this.selectedConversation = null;
        this.selectedNotifications = [];
      }
    // }
  }

  isWorkstationSelected(op: WorkstationOperatoryModel, workstation: WorkstationConfigurationModel) {
    if (!op || !op.selectedWorkstations) {
      return null;
    }
    return op.selectedWorkstations.includes(workstation);
  }

  onWorkstationClick(op: WorkstationOperatoryModel, workstation: WorkstationConfigurationModel) {
    if (op.selectedWorkstations.includes(workstation)) {
      const idx = op.selectedWorkstations.findIndex(p => p.WorkStationId === workstation.WorkStationId);
      if (idx > -1) {
        op.selectedWorkstations.splice(idx, 1);
      }
    } else {
      op.selectedWorkstations.push(workstation);
    }

    if (!this.selectedWorkstations.includes(workstation)) {
      this.selectedWorkstations.push(workstation);
    } else {
      const idx = this.selectedWorkstations.findIndex(p => p.WorkStationId === workstation.WorkStationId);
      if (idx > -1) {
        this.selectedWorkstations.splice(idx, 1);
      }
    }
  }

  onMainChange(event: MatCheckboxChange, op: WorkstationOperatoryModel) {
    if (event.checked) {
      op.selectedWorkstations = op.workstations.concat();

      for (const model of op.workstations) {
        if (!this.selectedWorkstations.includes(model)) {
          this.selectedWorkstations.push(model);
        }
      }

    } else {
      op.selectedWorkstations = [];
      for (const model of op.workstations) {
        if (this.selectedWorkstations.includes(model)) {
          const idx = this.selectedWorkstations.findIndex(p => p.WorkStationId === model.WorkStationId);
          if (idx > -1) {
            this.selectedWorkstations.splice(idx, 1);
          }
        }
      }
    }
  }

  isAllChecked(op: WorkstationOperatoryModel) {
    return op.workstations.length === op.selectedWorkstations.length;
  }

  onAddPredefinedMessage() {
    const message = new NotificationMessageDataModel();
    message.Message = 'New Message';
    message.morder = this.predefinedMessages.length;
    message.enumNotificationMsgTypeID = this.notificationType;
    this.editedPredefinedMessages.push(message);
    this.predefinedMessages.push(message);
  }

  onEditPredefinedMessage(message: NotificationMessageDataModel) {
    this.messageInEditMode = message;
    if (!this.editedPredefinedMessages.includes(message)) {
      this.editedPredefinedMessages.push(message);
    }
  }

  onEditPredefinedMessageFinished(message: NotificationMessageDataModel) {
    this.messageInEditMode = null;
    if (!this.editedPredefinedMessages.includes(message)) {
      this.editedPredefinedMessages.push(message);
    }
    this.notificationService.savePredefinedMessages(this.editedPredefinedMessages).subscribe((res) => {
      this.editedPredefinedMessages = [];
    });
  }

  onSelectPredefinedMessage(message: NotificationMessageDataModel) {
    if (this.selectedMessage === message) {
      this.selectedMessage = null;
    } else {
      if (!this.selectedMessage) {
        this.selectedMessage = new NotificationMessageDataModel();
        this.selectedMessage.Message = '';
      }

      this.chatInput += ' ' + message.Message;
      this.selectedMessage.Message += ' ' + message.Message;

      /*if (this.currentTabName === 'Instant Message') {
        const newMessage = new NotificationMessageDataModel();
        this.chatInput += ' ' + message.Message;
        newMessage.Message = this.chatInput;
        this.selectedMessage = newMessage;
      } else {
        this.selectedMessage = message;
      }*/
    }
  }

  isMessageSelected(message: NotificationMessageDataModel) {
    return this.selectedMessage === message;
  }

  scrollToBottom(): void {
    if (!this.messageContainer) {
      return;
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = false;
    }

    try {
      this.scrollTimeout = setTimeout(_ => {
        this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
      }, 200);
    } catch (err) {
      console.log('error');
      this.scrollTimeout = setTimeout(_ => {
        this.scrollToBottom();
      }, 200);
    }
  }

  /*onTabChange(event: MatTabChangeEvent) {
    this.currentTabName = event.tab.textLabel;
    if (this.currentTabName === 'Page') {
      this.notificationType = this.ENUM_NOTIFICATION_TYPE_PAGE;
    } else {
      if (this.currentTabName === 'Instant Message') {
        this.notificationType = this.ENUM_NOTIFICATION_TYPE_IM;
      }
    }
  }*/

  getPredefinedMessages() {
    return this.predefinedMessages.filter(p => p.enumNotificationMsgTypeID === this.notificationType);
  }

  togglePriority() {
    if (this.selectedPriorityId === this.ENUM_NOTIFICATION_PRIORITY_NORMAL) {
      this.priority = 'P1';
      this.selectedPriorityId = this.ENUM_NOTIFICATION_PRIORITY_PRIORITY1;
    } else {
      this.priority = 'N';
      this.selectedPriorityId = this.ENUM_NOTIFICATION_PRIORITY_NORMAL;
    }
  }

  onCustomMessageFinished(event: any) {
    if (!this.selectedMessage) {
      this.selectedMessage = new NotificationMessageDataModel();
      this.selectedMessage.Message = '';
    }
    if (this.selectedMessage.Message.length > 0) {
      this.selectedMessage.Message += ' ';
    }
    this.selectedMessage.Message = event;
    this.selectedMessage.enumNotificationMsgTypeID = this.notificationType;
  }

  onSelectConversation(conv: NotificationConversationDataModel) {
    this.selectedConversation = conv;
    this.notificationService.getDestinations(this.selectedConversation.ConversationID).subscribe((destinations) => {
      this.destinations = destinations;

      this.isShowConversations = false;

      this.selectedNotifications = [];

      for (const des of this.destinations) {
        this.selectedNotifications.push(des.dataNotification);
      }

      this.selectedNotifications = this.selectedNotifications.sort((a, b) => {
        const aDate = new Date(a.xauditModifiedOn);
        const bDate = new Date(b.xauditModifiedOn);
        return aDate.getTime() - bDate.getTime();
      });
      setTimeout(() => {
        this.scrollToBottom();
      }, 400);
    });

    // this.selectedConversationDestinationGroup = dest;
    /*if (dest.length > 0) {
      this.selectedConversation = dest[0].dataNotificationConversation;
    }*/
  }

  getUserBackgroundColor(user: TdoUserConfigurationModel) {
    if (this.colorSchemes) {
      const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user.ColorSchemeID.toLowerCase());
      if (scheme) {
        return scheme.BackColor;
      }
    }
  }

  getUserForgroundColor(user: TdoUserConfigurationModel) {
    if (this.colorSchemes) {
      const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user.ColorSchemeID.toLowerCase());
      if (scheme) {
        return scheme.ForeColor;
      }
    }
  }

  onNewCheckBoxChange(event: MatCheckboxChange) {

  }
}
